import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home-About.css'


const HomeAboutSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const fullDescription = "KLM paper bags are made from the finest quality paper. Our bags are a popular choice because these are eco-friendly, biodegradable, and recyclable.These bags are made from trees, a sustainable resource, and require less energy and toxic waste to make than plastics bags. We are specialist in design and manufacturing eco-friendly products like Brown/White Paper Bags, and SOS Bags. We are equipped with a fully automatic bag making and printing machines, offset machine etc. Not only that, but we deliver products of the best quality, price, service and reliability. KLM believes in customer satisfaction and leaves no stone unturned to give the best services in the industry. KLM Paper bags have become more efficient and cost effective over time. We must ensure that our products meet safety and quality standards in Target markets.  KLM Paper bags can be reused multiple times to reduce the environmental impact.";

  return (
    <section className="about-section py-5 overflow-hidden bg-section w-100 ">
      <div className="container">
        <div className="row align-items-center">
          {/* Left side images */}
          <div className="col-lg-6 col-md-12 position-relative mb-5 mb-lg-0">
            <div className="images-container position-relative">
              {/* Main image */}
              <div className="main-image-container position-relative">
                {/* <div className="trusted-badge">
                  <div className="badge-content">
                    <div className="badge-text">TRUSTED BY</div>
                    <div className="badge-number">8900</div>
                  </div>
                </div> */}
                <img 
                  src="/assets/products-with-logo/home-about-image1.png"
                  alt="klm-bags" 
                  className="main-image img-fluid rounded shadow"
                />
              </div>
              
              {/* Bottom hay bale image */}
              {/* <div className="hay-bale-container">
                <img 
                  src="/assets/products-with-logo/klm-all-bags.png"
                  alt="colorful-bags" 
                  className="colorful-bags-image img-fluid rounded shadow"
                />
              </div> */}
            </div>
          </div>

          {/* Right side content */}
          <div className="col-lg-6 col-md-12 content-section">
            <div className="content-wrapper">
              {/* Logo and Welcome text */}
              <div className="welcome-section">
                <img 
                  src="/assets/logos/klm000.png"
                  alt="Klm logo" 
                  className="logo"
                />
                {/* <p className="text-muted mb-0 small">WELCOME TO KLM</p> */}
              </div>

              {/* Main heading */}
              {/* <h2 className="main-heading">
                Better Packaging for Better Future
              </h2> */}

              {/* Experience text */}
              {/* <p className="experience-text">
                We have 30 years of experience in packaging
              </p> */}

              {/* Description with expansion functionality */}
              <div className="description-container">
                <p 
                  className="description-text" 
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: isExpanded ? 'unset' : '4',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {fullDescription}
                </p>
              </div>

              {/* Features */}
              <div className="features-grid">
                <div className="feature-item">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon">
                      <img 
                        src="/assets/icons/professional-packagers.svg"
                        alt="Professional Packagers icon" 
                        className="img-fluid"
                      />
                    </div>
                    <div>
                      <h5 className="feature-title">Professional Packagers</h5>
                    </div>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon">
                      <img 
                        src="/assets/icons/premiumquality.svg"
                        alt="Organic & Eco Solutions icon" 
                        className="img-fluid"
                      />
                    </div>
                    <div>
                      <h5 className="feature-title">Premium Quality</h5>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA Button with expansion functionality */}
              <button 
                className="cta-button btn btn-danger btn-lg"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? 'Show Less' : 'Discover More'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAboutSection;